import { Link } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import Conviction from '../components/lens/Conviction'
import LensBand from '../components/lens/LensBand'
import VerdictLegend from '../components/lens/VerdictLegend'
import LoginGate from '../components/common/LoginGate'
import ProGate from '../components/common/ProGate'
import UnscharfeIdeen from '../components/common/UnscharfeIdeen'
import { Fehler, Laden, Leer } from '../components/common/States'
import { useTopIdeas } from '../hooks/useQualyz'
import { formatDezimal } from '../lib/lenses'
import { grenzenVon } from '../lib/tarife'

export default function TopIdeasPage() {
  const { isAuthenticated, isLoading } = useAuth()
  if (isLoading) return null
  if (!isAuthenticated) {
    return (
      <div className="q-page">
        <section className="q-card">
          <LoginGate titel="Die Top-Ideen sind für angemeldete Nutzer." zeilen={6} />
        </section>
      </div>
    )
  }
  return <Liste />
}

/** Die fertige Antwort des Tages -- anders als der Screener ohne Stellschrauben. */
function Liste() {
  const { user } = useAuth()
  const top = useTopIdeas(20)
  const liste = top.data ?? []
  // Kostenlose Konten bekommen zehn Titel (tarife.py); dahinter der Hinweis auf Pro.
  const grenze = grenzenVon(user).ideen
  const gekuerzt = grenze !== null && liste.length >= grenze

  return (
    <div className="q-page">
      <VerdictLegend />
      {top.isPending ? (
        <section className="q-card">
          <Laden
            text="Die Linsen rechnen …"
            hinweis="Beim ersten Abruf nach einer Aktualisierung dauert das bis zu 40 Sekunden."
          />
        </section>
      ) : top.isError ? (
        <section className="q-card">
          <Fehler fehler={top.error} nochmal={() => top.refetch()} />
        </section>
      ) : liste.length === 0 ? (
        <section className="q-card">
          <Leer text="Heute keine Ideen mit ausreichender Datengrundlage." />
        </section>
      ) : (
        <>
          <div className="q-idea-grid">
            {liste.map((idea) => (
              <article key={idea.symbol} className="q-card q-idea">
                <div className="q-idea-head">
                  <Conviction wert={idea.conviction} von={idea.lenses_total} groesse="lg" />
                  <Link
                    className="q-titlelink"
                    to={`/aktie/${encodeURIComponent(idea.symbol)}`}
                    title={`${idea.symbol} im Detail ansehen`}
                  >
                    <div className="q-titlecell">
                      <span className="q-sym q-sym--lg">{idea.symbol}</span>
                      <span className="q-name" title={idea.name}>
                        {idea.name}
                      </span>
                      {idea.sector && <span className="q-sector">{idea.sector}</span>}
                    </div>
                  </Link>
                </div>
                <LensBand idea={idea} />
                <div className="q-idea-foot">
                  <span>
                    Ø Score <span className="q-mono">{formatDezimal(idea.avg_score, 1)}</span>
                  </span>
                  <span>
                    {idea.lenses_judged} von {idea.lenses_total} Linsen urteilen
                  </span>
                </div>
              </article>
            ))}
          </div>
          {gekuerzt && (
            <section className="q-card">
              <ProGate titel="Weitere Top-Ideen mit Pro" vorschau={<UnscharfeIdeen anzahl={4} />} />
            </section>
          )}
        </>
      )}
    </div>
  )
}
